<template>
  <div>
    <DefaultMenu>
      <template #title>
        Capacitaciones
      </template>
  
        <b-button
          v-permission="'capacitaciones-menu-crear'"
          @click="toggleModalCreateCourse"
          v-b-tooltip.hover.left
        >
          <b-icon icon="plus-circle"/>
          Agregar curso
        </b-button>
      <template #right>
        <b-button
            v-permission="'capacitaciones-configuracion'"
            @click="toggleModalSetting"
            title="Configuración"
            v-b-tooltip.hover.left
        >
          <b-icon icon="gear"/>
        </b-button>
      </template>
        
    </DefaultMenu>
    
    <BaseModal v-model="modalShowSetting" size="xl">
        <TrainingSetting/>
    </BaseModal>

    <BaseModal v-model="modalShowCourseForm" size="md">
      <CourseForm/>
    </BaseModal>

  </div>
</template>

<script>
import DefaultMenu from "@/components/shared/Default-menu.vue"
import CourseForm from "./TrainingMenu/Course-form.vue";
import BaseModal from "@/components/shared/Base-modal.vue"
import TrainingSetting from "./TrainingMenu/Training-setting.vue"

export default {
  name: 'TrainingMenu',

  components: {
    DefaultMenu,
    BaseModal,
    TrainingSetting,
    CourseForm
  },

  data() {
    return {
      modalShowSetting: false,
      modalShowCourseForm: false
    }
  },

  methods: {
    toggleModalSetting() {
      this.modalShowSetting = !this.modalShowSetting
    },

    toggleModalCreateCourse() {
      this.modalShowCourseForm = !this.modalShowCourseForm
    }
  }
}
</script>

